import { useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { SOCIALS } from "../constants/socials";
import { SHOP_LINKS } from "../constants/shop-links";
import { SUPPORT_LINKS } from "../constants/support-links";
import { COMPANY_LINKS } from "../constants/company-links";
import { useForm } from "react-hook-form";
export function useFooterState() {
    const navigate = useNavigate();
    const { formState: { errors }, register, handleSubmit: handleSubmitNewsletter, } = useForm();
    const socials = useMemo(() => SOCIALS, []);
    const shopLinks = useMemo(() => SHOP_LINKS, []);
    const supportLinks = useMemo(() => SUPPORT_LINKS, []);
    const companyLinks = useMemo(() => COMPANY_LINKS, []);
    const handleSocialClicked = useCallback((url) => () => {
        navigate(url);
    }, []);
    return useMemo(() => ({
        errors,
        handleSocialClicked,
        handleSubmitNewsletter,
        register,
        shopLinks,
        socials,
        supportLinks,
        companyLinks,
    }), [errors, handleSocialClicked, handleSubmitNewsletter, register, shopLinks, socials, supportLinks, companyLinks]);
}
